import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { cancelWaitingForAdmission } from 'flow/actions/meeting-actions';
import IconButton from 'flow/components/ui-components/IconButton';

/**
 * The way out of the waiting room (VID-76), which is all this slot offers once
 * the join has been asked for and the answer is somebody else's to give.
 *
 * The wait itself is shown over the video — see MeetingLobbyAdmissionNotice —
 * so nothing needs saying here beyond the way to stop.
 */
const LobbyButtonCancelWaiting = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    return (
        <IconButton
            data-test-id="meeting-cancel-waiting-button"
            className="bg-red h-10 shrink-0 rounded-2xl px-6 text-sm font-bold text-white"
            onClick={() => dispatch(cancelWaitingForAdmission())}
        >
            {i18next.t('videoconference.waiting_room.cancel')}
        </IconButton>
    );
};

export default LobbyButtonCancelWaiting;
